/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropdraw1Inputs */

const en_dropdraw1 = /** @type {(inputs: Dropdraw1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run draw`)
};

const de_dropdraw1 = /** @type {(inputs: Dropdraw1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziehung starten`)
};

/**
* | output |
* | --- |
* | "Run draw" |
*
* @param {Dropdraw1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropdraw1 = /** @type {((inputs?: Dropdraw1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropdraw1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropdraw1(inputs)
	return de_dropdraw1(inputs)
});
export { dropdraw1 as "dropDraw" }